import { useEffect } from "react";
import {
  Outlet,
  useLocation,
  useMatches,
  useSearchParams,
} from "react-router-dom";

const Root = () => {
  const matches = useMatches();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check if there's a taskTitle in the URL params first
    const taskTitle = searchParams.get("taskTitle");

    if (taskTitle) {
      // Use the dynamic task title if available
      document.title = taskTitle;
    } else {
      // Otherwise, use the route's handle title
      const matchWithTitle: any = matches.find(
        (match: any) => match.handle?.title
      );
      if (matchWithTitle) {
        document.title = matchWithTitle.handle.title;
      } else {
        document.title = "Aladdin"; // fallback title
      }
    }
  }, [location, matches, searchParams]);
  // const navigate = useNavigate();

  // useEffect(() => {
  //   onAppDidMount(navigate);
  // }, [navigate]);

  return <Outlet />;
};
export default Root;
